<template >
  <div class="btn-wrap" :class="realBtnClass" :style="finallyStyle"></div>
</template>
<script>
import positionMixin from "./positionMixin";
export default {
  mixins: [positionMixin],
  data() {
    const supportTypes = ["next", "finish", "skip"];
    let realBtnType = 0;
    if (typeof this.btnType === "number") {
      //validator
      realBtnType = this.btnType;
    } else if (typeof this.btnType === "string") {
      const posIndex = supportTypes.indexOf(this.btnType);
      //     debugger;
      realBtnType = posIndex !== -1 ? posIndex : 0;
    }
    return {
      supportTypes,
      realBtnType
    };
  },
  watch: {
    btnType() {
      if (typeof this.btnType === "number") {
        this.realBtnType = this.btnType;
      } else if (typeof this.btnType === "string") {
        const posIndex = this.supportTypes.indexOf(this.btnType);
        this.realBtnType = posIndex !== -1 ? posIndex : 0;
      }
    }
  },
  computed: {
    realBtnClass() {
      return `${this.$i18n.locale}-${this.supportTypes[this.realBtnType]}`;
    }
  },
  props: {
    btnType: {
      type: [String, Number],
      validator(e) {
        if (typeof e === "number") {
          // number
          return /^[0-2]$/.test(e);
        }
        return true;
      },
      default: "next"
    }
  }
};
</script>
<style lang='stylus' scoped>
.btn-wrap {
  positionFunc($x = -402px, $y = -572px) {
    background-position-x: $x;
    background-position-y: $y;
  }

  &.en-next {
    positionFunc(2px, -1087px);
  }

  &.en-finish {
    positionFunc(2px, -910px);
  }

  &.en-skip {
    positionFunc(-402px, -952px);
  }

  &.zh-CN-next {
    positionFunc();
  }

  &.zh-CN-finish {
    positionFunc(-402px, -389px);
  }

  &.zh-CN-skip {
    positionFunc(-294px, -33px);
  }

  &.zh-TW-next {
    positionFunc();
  }

  &.zh-TW-finish {
    positionFunc(-402px, -389px);
  }

  &.zh-TW-skip {
    positionFunc(-402px, -755px);
  }

  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 52px 52px 75px 55px;
  z-index: 1;
  cursor: pointer;
  width: 320px;
  height: 150px;
  position: absolute;
  background-repeat: no-repeat;
  background-image: url('../../../assets/indication/indication.png');
}
</style>
